import { Link } from "react-router-dom";
import { Column } from "react-table";
import { formatDate } from "../../api/DateUtils";
import { IIncidentCorrectiveAndPreventativeAction } from "../../api/Incident/IIncidentCorrectiveAndPreventativeAction";
import { GetIncidentUpdateRequestsFetchUrl } from "../../api/Incident/IIncidentUpdateRequest";
import { GetIncidentUpdateRequestPageUrl } from "../../leap-pages/routeFactory";
import { Grid } from "../Grid";
import { IncidentUpdateRequestsGridProps } from "./IncidentUpdateRequestsGridProps";

const renderRequest = (rowInfo: any) => (
  <div
    style={{
      display: "block",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    }}
    dangerouslySetInnerHTML={{ __html: rowInfo.value }}
  ></div>
);

const IncidentUpdateRequestsGrid = ({
  incidentId,
  licenceProfile,
}: IncidentUpdateRequestsGridProps) => {
  const getFetchUrlFactory = (relatedId: string) => {
    let fetchUrlFn = (
      pageNo: number,
      recordsPerPage: number,
      searchText: string,
      filters: any
    ) => {
      return GetIncidentUpdateRequestsFetchUrl(
        relatedId,
        pageNo,
        recordsPerPage,
        searchText,
        filters
      );
    };

    return fetchUrlFn;
  };

  const fetchUrl = getFetchUrlFactory(incidentId);

  const tableColumnsBig: Column<
    Record<string, IIncidentCorrectiveAndPreventativeAction>
  >[] = [
    {
      Header: "Date Issued by EPA",
      accessor: "datesubmitted",
      Filter: false,
      Cell: (rowInfo: any) => (
        <Link
          to={GetIncidentUpdateRequestPageUrl(
            licenceProfile.profileNo,
            rowInfo.row.original.incidentupdaterequestid
          )}
        >
          {formatDate(rowInfo.value)}
        </Link>
      ),
    },
    {
      Header: "Instruction / Request",
      accessor: "request",
      Filter: false,
      Cell: renderRequest,
    },
  ];

  const tableColumnsSmall: Column<
    Record<string, IIncidentCorrectiveAndPreventativeAction>
  >[] = [
    {
      Header: "Date Issued by EPA",
      accessor: "datesubmitted",
      Filter: false,
      Cell: (rowInfo: any) => formatDate(rowInfo.value),
    },
    {
      Header: "Instruction / Request",
      accessor: "request",
      Filter: false,
      Cell: renderRequest,
    },
  ];

  var bodyElements = (
    <div>
      <div className="d-md-none">
        <Grid
          columns={tableColumnsSmall}
          data={[]}
          fetchUrlFunction={fetchUrl}
          enablePagination={true}
          enableQuickFind={true}
        />
      </div>
      <div className="d-none d-md-block">
        <Grid
          columns={tableColumnsBig}
          data={[]}
          fetchUrlFunction={fetchUrl}
          enablePagination={true}
          enableQuickFind={true}
        />
      </div>
    </div>
  );

  return bodyElements;
};

export { IncidentUpdateRequestsGrid };
